import MobileDetect from 'mobile-detect';

const md = new MobileDetect(window.navigator.userAgent);

export default {
  install(Vue) {
    Vue.prototype.$isMobile = md.mobile();
  }
};
